import { TableCell, TableRow } from '@/components/ui/table';

export function LoadingTableRow({ numColumns }: { numColumns: number }) {
  return (
    <TableRow>
      <TableCell
        colSpan={numColumns}
        className="h-24 animate-pulse text-center"
      >
        Loading...
      </TableCell>
    </TableRow>
  );
}
